<!-- This doesn't do anything right now. Just shows and hides the drawer when clicking the menu icon -->
<template>
  <v-navigation-drawer
    temporary
    v-model="drawer"
    absolute
    class="nav-drawer"
  >
    <v-list class="pt-0">
      <v-list-tile class="hover-darken" @click="$router.push('/account')" v-if="loggedIn">
        <v-list-tile-action>
          <v-icon>account_box</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Account Settings</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile class="hover-darken" @click="$router.push('/')" v-if="loggedIn">
        <v-list-tile-action>
          <v-icon>list</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Projects</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile class="hover-darken" @click="copyInviteLink" v-if="loggedIn">
        <v-list-tile-action>
          <v-icon>person_add</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Invite Users</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile class="hover-darken" @click="$store.dispatch('users/logout')" v-if="loggedIn">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Log Out</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile class="hover-darken" @click="$router.push('/login'); toggleDrawer()" v-if="!loggedIn">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Log In</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <input
      class="invite-link-contents"
      ref="inviteLink"
      type="text"
      :value="inviteLink"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Drawer',
  data() {
    return {
      user: {},
      drawer: null,
    };
  },
  computed: {
    ...mapGetters({
      inviteLink: 'orgs/inviteLink',
      loggedIn: 'users/loggedIn',
    }),
  },
  created() {
    this.$parent.$on('toggleDrawer', this.toggleDrawer);
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    copyInviteLink() {
      this.$refs.inviteLink.select();
      document.execCommand('copy');
      this.$store.dispatch(
        'Notifications/flashMessage',
        { msg: 'Link copied to clipboard!', msgType: 'success' });
      this.toggleDrawer();
    },
  },
};
</script>

<style lang="scss">
.nav-drawer {
  background-color: white;
  padding-top: 60px;
}
.invite-link-contents {
  position: absolute;
  top: -30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Drawer.vue